<template>
  <md-dialog
    :md-active="isVisible"
    :md-backdrop="true"
    class="md-small-size-100"
  >
    <md-dialog-title>Fund Wallet</md-dialog-title>

    <md-dialog-content>
      <div v-if="isLoadingAccounts"><p>Getting account details...</p></div>
      <!-- Call to action Buttons -->
      <div v-else-if="!accounts.length">
        <div class="md-layout">
          <md-button
            class="md-raised md-layout-item md-primary"
            @click="createVirtualAccount()"
            :disabled="isCreateWalletLoading"
            >{{
              isCreateWalletLoading
                ? 'Creating Account...'
                : 'Create Virtual Account'
            }}</md-button
          >
        </div>
      </div>

      <!-- List of Providers -->
      <div v-else>
        <md-list
          class="md-double-line"
          v-for="(account, index) in accounts"
          :key="index"
        >
          <md-list-item class="md-inset">
            <div class="md-list-item-text">
              <h3>
                {{ account.bank }} <p>({{ account.provider }})</p>
              </h3>
              <br />

              <p>Account number:</p>
              <p>
                <b>{{ account.acc_num }}</b>
              </p>

              <br />

              <p>Account name:</p>
              <p>
                <b>{{ account.acc_name }}</b>
              </p>

              <!-- <span
                ><h3>
                  <b>{{ account.acc_num }}</b>
                </h3></span
              >
              <span>{{ account.acc_name }}</span> -->
            </div>
          </md-list-item>

          <md-divider></md-divider>
        </md-list>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <!-- <md-button class="md-primary" @click="confirm()">Add</md-button> -->
      <md-button class="md-accent" @click="close()">Close</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<style scoped></style>

<script>
import http from '../../utils/Http.util';

export default {
  name: 'fund-wallet-modal',
  watch: {
    isVisible() {
      if (this.isVisible) {
        this.getBankDetails();
      }
    },
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  data() {
    return {
      accounts: [],
      isVisible: false,
      isCreateWalletLoading: false,
      isLoadingAccounts: false,
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    open() {
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },
    confirm() {
      // Handle Confirm Event
    },
    async createVirtualAccount() {
      // this.$store.commit("busyStatus", true);
      this.isCreateWalletLoading = true;
      try {
        await http.authReq(
          '/dashboard/transfer-accounts',
          { phone: this.userData.phone },
          'post',
        );
        await this.getBankDetails();
        // this.$store.commit("busyStatus", false);
        this.isCreateWalletLoading = false;
      } catch (error) {
        // this.$store.commit("busyStatus", false);
        this.snackBar = {
          show: true,
          message: error.message,
        };
      }
      this.isCreateWalletLoading = false;
    },
    async getBankDetails() {
      // this.$store.commit("busyStatus", true);
      this.isLoadingAccounts = true;
      try {
        const { data } = await http.authReq('/dashboard/transfer-accounts');

        // this.$store.commit("busyStatus", false);

        this.accounts = data;
        this.isLoadingAccounts = false;
      } catch (error) {
        // this.$store.commit("busyStatus", false);
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
        this.isLoadingAccounts = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-menu-content {
  z-index: 11 !important;
}
.fund {
  width: 20vw !important;
}
</style>
